import { signInWithCustomToken } from '@firebase/auth';
import type { User } from '@firebase/auth';

import { auth } from './firebase';

export const getSignedInUser = async (): Promise<User | null> => {
	await auth.authStateReady();

	return auth.currentUser;
};

export const loginWithToken = async (customToken: string): Promise<void> => {
	await signInWithCustomToken(auth, customToken);
};

export const logout = (): Promise<void> => auth.signOut();
